import { render, staticRenderFns } from "./CampoArquivoDragAndDrop.vue?vue&type=template&id=70a8e61a&scoped=true&"
import script from "./CampoArquivoDragAndDrop.vue?vue&type=script&lang=js&"
export * from "./CampoArquivoDragAndDrop.vue?vue&type=script&lang=js&"
import style0 from "./CampoArquivoDragAndDrop.vue?vue&type=style&index=0&id=70a8e61a&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a8e61a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
